/**
 * @fileoverview GET handler for the "/engagement/in_app_message_color_profiles/territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInAppMessageColorProfilesTerritories } from "./constants";
import type { EngagementInAppMessageColorProfilesTerritoriesResult } from "./types";

export const getEngagementInAppMessageColorProfilesTerritories = reactQueryFetcherAdapter(
  engagementInAppMessageColorProfilesTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementInAppMessageColorProfilesTerritoriesResult> => {
    return fetch(
      "/engagement/in_app_message_color_profiles/territories",
      "GET",
      { app_group_id: appGroupId },
      { signal }
    );
  }
);
